import React from 'react';
import pt from 'prop-types';

const GoldAward = ({ year, className, trackingId }) => {
  if (!year) {
    return null;
  }

  return (
    <svg
      viewBox="0 0 539.71 256.47"
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
          <defs>
            <style>
              ${`.cls-12{fill:#fff}.cls-22{fill:#c48e00}.cls-32,.cls-42{fill:#fff}.cls-42{font-size:56.3px;font-family:Frutiger;font-weight:400;}`}
            </style>
          </defs>
          <path class="cls-12" d="M0 0h539.71v256.47H0z"></path>
          <g id="Ebene_1" data-name="Ebene 1">
            <path class="cls-22" ${
              trackingId && 'id="badge_gold"'
            } d="M13.27 13.27h256.47v230.47H13.27z"/>
            <path class="cls-32" d="M67.57 216h40.5v-94.51h-40.5ZM87.73 64.79a22.95 22.95 0 1 0 23 22.95 22.94 22.94 0 0 0-23-22.95Zm87.75 2.7V108H216V67.49Zm-54 148.51H162V67.49h-40.5Zm54-54H216v-40.51h-40.52Z" transform="translate(-.22 -13.5)"/>
            <path class="cls-22" d="M283.24 13.27h243.2v230.47H283.24z"/>
            <path class="cls-32" ${
              trackingId && 'id="Gold_Award"'
            } d="M346.79 75.63a21.75 21.75 0 0 0-9.7-2.16c-7.75 0-12.78 5.14-12.78 13.33 0 8 4.56 13.38 12.63 13.38a14.39 14.39 0 0 0 4.29-.56V90h-7.8v-6.19h14.83v20.74a36 36 0 0 1-12.32 2c-11.21 0-19.54-7.52-19.54-19.85 0-12 8.07-19.52 20.75-19.52a30 30 0 0 1 10.16 1.49ZM390.81 86.74c0 12.33-7.08 20.13-18 20.13S355.07 99.18 355.07 87c0-12.77 6.71-20 18.18-20 10.75-.06 17.56 7.52 17.56 19.74ZM363 87c0 8.41 4 13.88 10.07 13.88 5.81 0 9.9-5.64 9.9-13.93C383 78.28 379 73 372.84 73 367 73 363 78.5 363 87ZM397.89 67.61h7.39v32h14.2v6.64h-21.59ZM435.35 67.61c12.37 0 21.59 5.2 21.59 19.46 0 13.5-9.48 19.14-21.59 19.14h-10v-38.6Zm-2.62 32.68h1.94c8.12 0 14.62-3.37 14.62-13.27 0-10.4-6.5-13.33-14.62-13.33h-1.94ZM351.5 161.12h-8l-3.2-8.9H325l-3.19 8.9h-7.6l14.36-38.59h8.33Zm-16.24-23.77c-.79-2.33-2-6.75-2.51-8.74h-.11c-.52 2-1.89 6.41-2.67 8.74l-3 9h11.33ZM378 135.3c-.37-1.77-1.1-5.14-1.36-7.25h-.11c-.26 2.11-.84 5.42-1.2 7.25l-5.45 25.82h-9.33l-10.11-38.59h7.91l5.29 23.11c.26 1.27 1.42 6.86 1.73 9.46h.11c.36-2.6 1.41-8.19 1.67-9.46l4.77-23.11h9.8l5 23.11c.31 1.33 1.31 6.91 1.68 9.46h.1c.37-2.55 1.42-8 1.73-9.46l5.24-23.11h7.34L393 161.12h-9.28ZM438.76 161.12h-8l-3.2-8.9H412.3l-3.2 8.9h-7.6l14.36-38.59h8.33Zm-16.25-23.77c-.78-2.33-2-6.75-2.51-8.74h-.11c-.52 2-1.88 6.41-2.67 8.74l-3 9h11.37ZM443.69 122.53h10.58c9 0 15 2 15 10.11 0 5.09-2.89 8.13-7.65 9.13v.11c2.57.72 3.51 2.27 4.66 5.14l5.66 14.1h-8.12l-4.09-10.94c-1.52-4-2.2-5.09-6.71-5.09h-1.94v16h-7.38Zm7.38 16.59h2.15c5.82 0 8.44-1.55 8.44-5.42 0-4.21-3.14-5.09-8.44-5.09h-2.15ZM488.28 122.53c12.37 0 21.59 5.19 21.59 19.46 0 13.49-9.48 19.13-21.59 19.13h-10v-38.59Zm-2.62 32.68h1.94c8.12 0 14.62-3.38 14.62-13.27 0-10.4-6.5-13.33-14.62-13.33h-1.94Z" transform="translate(-.22 -13.5)"/>
            <text class="cls-42" ${
              trackingId && 'id="Award_Year"'
            } transform="translate(314.03 202.61)">${year}</text>
          </g>
        `,
      }}
    />
  );
};

GoldAward.propTypes = {
  year: pt.number.isRequired,
  className: pt.string,
  trackingId: pt.bool,
};

GoldAward.defaultProps = {
  className: '',
};

export default GoldAward;
